// src/components/dialog/DlgCloseButton.tsx

import { CloseTwoTone } from '@mui/icons-material'
import { IconButton, Tooltip, useTheme } from '@mui/material'

type DlgCloseButtonProps = {
  onClick?: () => void
}

export const DlgCloseButton = ({ onClick }: DlgCloseButtonProps) => {
  const theme = useTheme()
  const bgcolor = theme.palette.secondary.main
  const color = theme.palette.white

  return (
    <Tooltip title={'Schliessen'}>
      <IconButton
        onClick={onClick}
        sx={{
          bgcolor,
          color,
          transform: 'rotate(0deg)',
          transition: 'transform 0.2s',
          '&:hover': { bgcolor: 'red', transform: 'rotate(90deg)' },
        }}
      >
        <CloseTwoTone />
      </IconButton>
    </Tooltip>
  )
}
